import React from "react";
import { ArrowRight } from "react-feather";
import { Link } from "react-router-dom";
import { formatDate } from "utils/format";
import { usePosts } from "../api/getPosts";
import { Typography } from "components/Elements";
import { UPLOADS_URL } from "config";

export const LatestNews = () => {
  const postsQuery = usePosts();

  if (postsQuery.isLoading) {
    return <></>;
  }

  if (!postsQuery.data) return null;

  return (
    <div className="flex flex-col mb-4">
      <div className="text-blue-800 px-4 tracking-tight sm:text-xl mb-2">
        <span className="inline-block flex flex-row justify-between text-sm uppercase items-center">
          <Typography variant="danger" className="font-bold">
            Latest News
          </Typography>
          <Link
            to="/news"
            className="flex flex-row items-center hover:underline hover:text-red-500"
          >
            <Typography size="sm" variant="danger">
              Archives
            </Typography>
            <ArrowRight className="h-4 ml-1" />
          </Link>
        </span>
      </div>
      <div>
        <div>
          <div className="grid grid-cols-1">
            {postsQuery.data
              .filter((post) => !post.draft)
              .slice(0, 3)
              .map((post, index) => (
                <Link
                  key={index}
                  to={`/news/${post.slug}`}
                  className="my-1 text-blue-800"
                >
                  <div className="flex overflow-hidden rounded-xl p-4 bg-gray-100 hover:bg-gray-200 transition duration-300 cursor-pointer">
                    <div className="">
                      <Typography
                        variant="dark"
                        className="hover:underline uppercase text-lg font-semibold"
                      >
                        {post.title}
                      </Typography>
                      <Typography variant="dark" className="mt-2">
                        {post.excerpt}
                      </Typography>
                      <Typography variant="danger" size="xs" className="mt-2">
                        {formatDate(post.createdAt)}
                      </Typography>
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
